import styled from "styled-components";

export const FormComponent = styled.form`
  .materialize {
    overflow: hidden;
    padding: 0 1em 1em 1em;
  }
`;
